import { __awaiter, __generator } from "tslib";
import Vue from 'vue-ltur';
//@ts-ignore
import Game from '../Game/Game.vue';
import { store } from "ltur-state-engine";
Vue.config.productionTip = false;
var initializeGame = function () { return __awaiter(void 0, void 0, void 0, function () {
    var gameContainer, lturState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gameContainer = document.querySelectorAll('.gameContainer');
                lturState = store.getState();
                return [4 /*yield*/, new Promise(function (res) {
                        var unsub = store.subscribe(function () {
                            if (Vue.translate !== void 0 && lturState.websiteState.app.translations !== void 0) {
                                unsub();
                                res();
                            }
                        });
                    })];
            case 1:
                _a.sent();
                //@ts-ignore
                gameContainer.forEach(function (item) {
                    new Vue({
                        render: function (h) { return h(Game, {
                            props: {
                                //@ts-ignore
                                serviceGameId: item.dataset.servicegameid,
                                //@ts-ignore
                                serviceNewsletterId: item.dataset.servicenewsletterid,
                                //@ts-ignore
                                reference: item.dataset.reference,
                                //@ts-ignore
                                headline: item.dataset.headline,
                                //@ts-ignore
                                dataSafetyText1: item.dataset.datasafetytext1,
                                //@ts-ignore
                                dataSafetyText2: item.dataset.datasafetytext2,
                                //@ts-ignore
                                text1: item.dataset.text1,
                                //@ts-ignore
                                button: item.dataset.button,
                                //@ts-ignore
                                text2: item.dataset.text2,
                                //@ts-ignore
                                imageUrl: item.dataset.imageurl,
                                //@ts-ignore
                                webpImageUrl: item.dataset.webpimageurl,
                                //@ts-ignore
                                imageAltText: item.dataset.imagealttext,
                                //@ts-ignore
                                imageClass: item.dataset.imageclass,
                                //@ts-ignore
                                sizeClass: item.dataset.sizeclass,
                                //@ts-ignore
                                promoId: typeof item.dataset.promoid !== 'undefined' ? item.dataset.promoid : '',
                                //@ts-ignore
                                promotion: typeof item.dataset.promotion !== 'undefined' ? item.dataset.promotion : '',
                                //@ts-ignore
                                name: typeof item.dataset.name !== 'undefined' && item.dataset.plz == "true",
                                //@ts-ignore
                                plz: typeof item.dataset.plz !== 'undefined' && item.dataset.plz == "true"
                            }
                        }); },
                    }).$mount(item);
                });
                return [2 /*return*/];
        }
    });
}); };
export default initializeGame;
